import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import React, { useEffect } from "react";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import BillingDetailsForm from "./BillingDetailsForm";
import { useDispatch, useSelector } from "react-redux";
import { fetchAddresses } from "../../redux/action/authAction";
import { fetchCartDetails } from "../../redux/action/orderAction";

const Checkout = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.orderReducer);

  useEffect(() => {
    dispatch(fetchAddresses());
    dispatch(fetchCartDetails());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Checkout"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Checkout", path: `${pageRoutes?.home}/` },
        ]}
      />
      <BillingDetailsForm />
      <Footer />
    </div>
  );
};

export default Checkout;
